import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "status_confirmed": {
        id: 'calendar_event.status.confirmed_label',
        defaultMessage: 'Confirmed',
    },
    "status_cancelled": {
        id: 'calendar_event.status.cancelled_label',
        defaultMessage: 'Cancelled',
    },
})

class CalendarEventStatusSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            selectedOptions: this.props.value || []
        }
        this.state.options = [
            {
                value: 'confirmed',
                label: this.props.intl.formatMessage(messages["status_confirmed"])
            },
            {
                value: 'cancelled',
                label: this.props.intl.formatMessage(messages["status_cancelled"])
            },
        ]

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOptions) {
        this.setState({
            selectedOptions: selectedOptions
        }, () => {
            this.onChange(selectedOptions.map(option => option.value), selectedOptions.map(option => option.label))
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(CalendarEventStatusSelect)





// WEBPACK FOOTER //
// ./src/scheduling-page/calendareventstatusselect.component.jsx